<template>
  <div class="form" v-if="recipientList.length>0">

    <div class="row mt-2">
      <div class="col-12">
        <b>To: </b>
        <div v-for="r in sendToList" class="pillBox">
          {{r.Name}} <button class="btn-transparent" @click="removeSendTo(r.ClientID)">X</button>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <b-form-select v-model="selectedRecipient" :options="recipientList" class="w50"></b-form-select> <button class="btn-std" @click="addRecipient">Add (+)</button>
      </div>
    </div>
    <div class="row mt-3" v-if="allowForceEmail===true">
      <div class="col-12">
        <input type="checkbox" class="checkbox" v-model="forceToEmail" /> Send directly to recipient email address (does not send a SIMmersion message). Recipient account must have an email address
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b>Subject:</b><br />
        <input type="text" id="msgsubject" v-model="subject" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b>Message:</b><br />
        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
      </div>
    </div>

    <div class="row mt-3" v-show="forceToEmail===false">
      <div class="col-12">
        <b>Attachment:</b> <input type="file" id="attachmentinput" ref="tfiles" @change="getFile" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 text-right">
        <button class="btn btn-primary btn-short" @click="doSend">Send</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .pillBox {
    margin-right: 10px;
    display: inline-block;
    border: 1px solid #999;
    border-radius: 6px;
    padding: 2px 5px;
    background-color: #DDD;
  }
</style>

<script>
   import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

   export default {
      name: "SendMessage",
      props:[
         "allowForceEmail",
         "licensePoolID",
         "presetAddresses",
         "routeOnSend"
      ],
      data() {
        return {
            fdata: null,
            fname: null,
            forceToEmail: false,
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
              toolbar: {
                items: [
                  'heading',
                  '|',
                  'bold',
                  'italic',
                  '|',
                  'bulletedList',
                  'numberedList',
                  'blockQuote',
                  '|',
                  'link',
                  '|',
                  'insertTable',
                  '|',
                  'undo',
                  'redo'
                ]
              },
              table: {
                contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
              },
              language: 'en'
            },
            recipientList:[],
            selectedRecipient: null,
            sendToList: [],
            subject:"",
            tcapiData:null
        }
      },
      methods: {
        addRecipient() {
          if (this.selectedRecipient!==null) {
            if (this.selectedRecipient.length===36) {
              if (this.sendToList.indexOf(this.selectedRecipient)===-1) {
                this.sendToList.push({Name: this.lookupName(this.selectedRecipient), ClientID: this.selectedRecipient});
              }
            }
            else {
              for(var i of this.tcapiData[this.selectedRecipient].Items) {
             
                this.sendToList.push({
                  Name: i.Name,
                  ClientID: i.ClientID
                })
                
              }
            }
          }
        },     
        doSend() {
          if (this.sendToList.length===0) {
            this.popDialog(1, "At least one recipient is required");
          }
          else if (this.subject.length===0) {
            this.popDialog(1, "Subject is required");
          }
          else if (this.editorData.length===0) {
            this.popDialog(1, "Message is required");
          }
          else {

            if (this.forceToEmail) {
              var commands=[];

              for (var i of this.sendToList) {

                var newItem = {
                  Operation: "LicensePool",
                  Function: "SendPoolMessage",
                  Fields: {
                    ClientID: i.ClientID,
                    LicensePoolID: this.licensePoolID,
                    Message: this.editorData
                  }
                };

                commands.push(newItem);
              }

              this.apiCommand(commands).then(response=> {
                 this.popDialog(0, "Message Sent");
                 this.$parent.goBack();
               });

            }
            else {

              var rList=[];
              for(var i of this.sendToList) {
                rList.push(i.ClientID);
              }

              var fldObj = {
                ToClient: rList,
                Subject: this.subject,
                Message: this.editorData
              };

              if (this.fdata !== null) {
                fldObj.AttachmentName=this.fname;
                fldObj.Attachment=this.fdata;
              }

              this.apiCommand(
                [{
                  Operation: "Client",
                  Function: "AddMessage",
                  Fields: fldObj
                }]).then(response=> {
                  this.popDialog(0, "Message Sent");
                  this.$router.push(this.routeOnSend);
                });
             
            }
          }
        },
        getFile(event) {
      
          var r = new FileReader();
          var self=this;
          r.onload = function (e) {
            self.fdata = e.target.result;
          }
          this.fname = this.$refs["tfiles"].files[0].name;
          r.readAsDataURL(this.$refs["tfiles"].files[0]);
        },
        lookupName(cliID) {
          for(var i of this.tcapiData) {
            for (var si of i.Items) {
              if (si.ClientID===cliID) {
                return si.Name;
              }
            }
          }
        },
        removeSendTo(cliID) {
          var rid=-1;
          for(var x=0; x<this.sendToList.length; x++) {
            if (this.sendToList[x].ClientID===cliID) {
              rid=x;
            }
          }
          if (rid>-1) {
            this.sendToList.splice(rid,1);
          }
        }
      },
      mounted() {

        this.apiCommand(
          [
              {
                Operation: "Client",
                Function: "GetMessageRecipients",
                Fields: {}
              }
          ]).then(response=> {

            this.recipientList.push({
              text: "--- Select ---",
              value: null
            });

            var x=0;
            var cr = JSON.parse(response.CommandResult);
            this.tcapiData=JSON.parse(cr.returnObjects[0].returnObject);

            for(var i of this.tcapiData) {
       
              this.recipientList.push({
                html: i.Name,
                value: x
              })
              x++;

              for (var si of i.Items) {
                this.recipientList.push({
                  html: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+si.Name,
                  value: si.ClientID
                })
              }
            }
            
            if (this.presetAddresses!==null && this.presetAddresses.length>0) {
              for(var a of this.presetAddresses) {
  
                if (typeof(a)==="object") {
                  this.sendToList.push({
                    Name: a.Name,
                    ClientID: a.ClientID
                  })
                }
                else {
                  this.sendToList.push({
                    Name: this.lookupName(a),
                    ClientID: a
                  })
                }
              }
            }
        });
      }
   }
</script>
